import React, { useEffect, useState } from "react";
import gsap from "gsap";
import { Power4 } from "gsap/all";

import Screen from "./splash.png";

const SplashScreen = () =>{

    const[visible,setVisible] = useState(true);

    useEffect(() =>{
        const value = localStorage.getItem('LavCal23');

        if(value != 'true' && visible){
            document.body.style.overflow = "hidden"
            gsap.to(".reference",1.5,{
                translateZ: "600px",
                ease: Power4.easeIn,
                delay:1,
                onUpdate: function(){
                    this.targets().forEach(function(target) {
                        target.style.transform = "perspective(5px)" + target.style.transform.replace("perspective(600px)", " ");
                    });
                },
                onComplete: (e) => {
                    setVisible(false);
                    localStorage.setItem('LavCal23', 'true');
                    document.body.style.overflowY = "auto"
                }
            })
        }
        else setVisible(false)
            
    })


    return visible && <div className="reference" style={{ backgroundImage: `url(${Screen})`,backgroundPosition:"center", position: "fixed", zIndex: 10, top: 0, width:"100vw", height: "100vh", transform: "translateZ(1)"}} />
}

export default SplashScreen